export default function SVG_Linear_Gradient() {
  return (
    <div>
      <h1>SVG_Linear_Gradient Component</h1>
    </div>
  );
}
